import { federatedSignInWithRedirect } from '@modules/authentication/utils';
import { LoadingButton } from '@mui/lab';
import { GoogleLogo } from 'common/Icons/Icons';
import { useState } from 'react';
import AuthService from 'services/AuthService';
import { createAnalyticsTracker } from 'v2/analytics/events';

const trackSignInEvents = createAnalyticsTracker('signIn');

export const SignInWithGoogle = () => {
  const [loader, setLoader] = useState(false);

  const federatedSignIn = async () => {
    setLoader(true);
    await federatedSignInWithRedirect();
    AuthService.setIsGoogleAuth();
    trackSignInEvents({ eventName: 'Sign in with Google CTA' });
  };

  return (
    <LoadingButton
      fullWidth
      size="large"
      variant="outlined"
      onClick={federatedSignIn}
      loading={loader}
      startIcon={<GoogleLogo height={24} width={24} />}
    >
      Sign in with Google
    </LoadingButton>
  );
};
